import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import Fetcher from 'services/Fetcher'
import {
  TContinueOnboardingSessionPayload,
  TGetMoovTokenRequest,
  TGetMoovTokenResponse
} from './types'

const fetcher = new Fetcher({})

export const getMoovToken = async (data: TGetMoovTokenRequest) =>
  fetcher.request<TGetMoovTokenRequest, TGetMoovTokenResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.ONBOARDING_SESSION}`,
    method: HTTP_METHODS.POST,
    data
  })

export const continueOnboardingSession = async (
  moov_account_id: string,
  onboadingSessionUuid: string
) =>
  fetcher.request<TContinueOnboardingSessionPayload, TGetMoovTokenResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.ONBOARDING_SESSION}${onboadingSessionUuid}/${API_DICTIONARY.CONTINUE}`,
    method: HTTP_METHODS.POST,
    data: {
      moov_account_id
    }
  })

export const completeOnboardingSession = async (onboadingSessionUuid: string) =>
  fetcher.request<TContinueOnboardingSessionPayload, TGetMoovTokenResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.ONBOARDING_SESSION}${onboadingSessionUuid}/${API_DICTIONARY.COMPLETE}`,
    method: HTTP_METHODS.POST
  })
